// dat文件解析页面

import React, { useState, useEffect, useRef } from 'react';
import { Tree, Splitter, Card, Typography, Button, Space, Tooltip, Flex, } from 'antd';
import { DownloadOutlined, EditOutlined } from '@ant-design/icons';

import { parseDatForTree } from './utils/parseDatForTree';
import { encodeDAT } from './utils/encodeDat';
import EditingPage from './EditingPage';

const { Text } = Typography;

// 动态引入 iconv-lite 和 buffer（避免顶层依赖导致 Webpack 报错）
let iconv;
let BufferPolyfill = null;

function ensureIconvAndBuffer() {
    if (iconv && BufferPolyfill) return;

    // 注入 Buffer 到全局（iconv-lite 需要）
    if (typeof window !== 'undefined') {
        if (!window.Buffer) {
            const { Buffer } = require('buffer');
            window.Buffer = Buffer;
        }
        BufferPolyfill = window.Buffer;
    }

    // 动态 require iconv-lite
    iconv = require('iconv-lite');
}

const DecodePage = ({ file, backToDraggerPage }) => {
    // 文件名
    const fileName = useRef('');
    // 原始文件内容
    const [originTreeData, setOriginTreeData] = useState([]);
    // 解析后的文件内容
    const [parsedTreeData, setParsedTreeData] = useState([]);
    // 是否进入编辑页
    const [isEditing, setIsEditing] = useState(false);
    // 需要编辑的文件内容
    const [fileContent, setFileContent] = useState('');

    useEffect(() => {
        if (!file) return;
        handleFileUpload(file);
    }, [file]);

    // 解析文件
    const handleFileUpload = async (file) => {
        try {
            // 获取文件名
            fileName.current = file.name || 'unknown.dat';
            // 读取文件内容
            const reader = new FileReader();
            reader.onload = (e) => {
                const datContent = e.target.result;
                const result = parseDatForTree(datContent);
                setOriginTreeData(result.enhancedOriginTreeData);
                setParsedTreeData(result.parsedTreeData);
            };
            // 错误处理
            reader.onerror = (e) => {
                console.error('Error reading file:', e);
            };
            // 👇 必须调用这个！否则不会读取
            reader.readAsText(file, 'GB2312'); // 如果是文本文件
        } catch (error) {
            console.error('Error reading file:', error);
        }
    }

    // 导出整理后的文件
    const exportData = () => {
        if (parsedTreeData.length === 0) return;

        try {
            // 确保依赖已加载
            ensureIconvAndBuffer();

            const content = encodeDAT(parsedTreeData);

            // 使用 iconv-lite 编码为 GB2312（返回 Uint8Array）
            const gb2312Buffer = iconv.encode(content, 'GB2312');

            const blob = new Blob([gb2312Buffer], {
                type: 'text/plain;charset=gb2312',
            });

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName.current;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('导出 GB2312 文件失败:', err);
            alert('导出失败：' + (err.message || '未知错误'));
        }
    }

    // 前往编辑页面
    const handleGoToEditingPage = () => {
        // 转为文本
        const content = encodeDAT(parsedTreeData);
        setFileContent(content);
        setIsEditing(true);
    };


    return (
        <div style={{ width: '100%', height: '100%' }}>
            {isEditing === false &&
                <Space direction="vertical" size="middle" style={{ width: '100%', height: '100%' }}>
                    <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                        <Text type="danger">注意：红色部分为已经删除的重复内容</Text>
                        <Button variant="outlined" onClick={backToDraggerPage}>返回并重新上传文件</Button>
                    </Flex>
                    <Splitter style={{ flex: 1, width: '100%' }} >
                        <Splitter.Panel defaultSize='50%' collapsible style={{ overflow: 'hidden', height: '100%' }}>
                            <Card title='原始文件内容' style={{ marginRight: 10 }}>
                                <Tree showLine treeData={originTreeData} />
                            </Card>
                        </Splitter.Panel>
                        <Splitter.Panel defaultSize='50%' collapsible style={{ overflow: 'hidden', height: '100%' }}>
                            <Card title='整理后文件内容' style={{ marginLeft: 10 }} extra={
                                <Space size="middle">
                                    <Tooltip title="编辑">
                                        <Button shape="circle" icon={<EditOutlined />} onClick={handleGoToEditingPage} />
                                    </Tooltip>
                                    <Tooltip title="导出">
                                        <Button shape="circle" icon={<DownloadOutlined />} onClick={exportData} />
                                    </Tooltip>
                                </Space>
                            }>
                                <Tree showLine treeData={parsedTreeData} />
                            </Card>
                        </Splitter.Panel>
                    </Splitter>
                </Space>
            }
            {isEditing === true && <EditingPage setIsEditing={setIsEditing} fileContent={fileContent} setParsedTreeData={setParsedTreeData} />}
        </div>
    );
};

export default DecodePage;